import { Col, Container, Row } from 'react-bootstrap'
import { Section, Button, Image, Title, MobileVRLogo, DesktopVRLogo, Body } from './VirginRedHero.styles'
import vrReward from '../../img/graphic-virgin-red-rewards.svg'
import vrLogoWhite from '../../img/vr-logo-white.svg'

export const VirginRedHero = () => (
  <Section>
    <Container>
      <Row>
        <Col className="d-flex flex-column">
          <DesktopVRLogo className="d-none d-lg-block" src={vrLogoWhite} alt="" />
          <Title>Save on train tickets sooner with Virgin Red</Title>
          <Body>
            <p>Virgin Red helps your points add up faster.</p>
            <p>Earn Virgin Points on groceries, getaways and brands you love.</p>
            Then use them to reduce the cost of your train journeys and treat yourself beyond the railway.
          </Body>
          <MobileVRLogo className="d-lg-none" src={vrLogoWhite} alt="" />
          <Button href="https://virgin.com/virgin-red" target="_blank">
            Join Virgin Red
          </Button>
        </Col>
        <Col className="d-none d-lg-flex">
          <Image src={vrReward} alt="" />
        </Col>
      </Row>
    </Container>
  </Section>
)
